import clsx from 'clsx';
import styles from './styles.module.css';
import { RetroBridgeLogoGradient, RetroGPTIcon } from '@/Assets/Icons/icons';

interface ModeSwitchProps {
  mode: 'bridge' | 'chatbot';
  setMode: (mode: 'bridge' | 'chatbot') => void;
}

export function ModeSwitch({ mode, setMode }: ModeSwitchProps) {
  return (
    <div
      className={clsx(
        styles.container,
        mode === 'chatbot' ? styles._2 : styles._1
      )}
    >
      <button className={styles.switchItem} onClick={() => setMode('bridge')}>
        <RetroBridgeLogoGradient
          fill={mode === 'bridge' ? 'white' : undefined}
        />
        Bridge
      </button>
      <button className={styles.switchItem} onClick={() => setMode('chatbot')}>
        <RetroGPTIcon fill={mode === 'chatbot' ? 'white' : undefined} />
        RetroGPT
      </button>
    </div>
  );
}
